"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractLpAndCfFromDatalakeTable = void 0;
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const DATALAKE_TABLE_DELIMITER = '_';
/**
 * Note that the extracted values are lower case since that's how
 * Datalake tables are set up
 */
const extractLpAndCfFromDatalakeTable = (tableName) => {
    const splitTable = tableName.split(DATALAKE_TABLE_DELIMITER);
    // *** Credit Facility ***
    if (tableName.startsWith(finley_types_1.DataLake.TablePrefix.BorrowingBaseReport) ||
        tableName.startsWith(finley_types_1.DataLake.TablePrefix.BorrowingBaseReportLatest) ||
        tableName.startsWith(finley_types_1.DataLake.TablePrefix.CashResponseTapes) ||
        tableName.startsWith(finley_types_1.DataLake.TablePrefix.CashResponseTapesLatest) ||
        tableName.startsWith(finley_types_1.DataLake.TablePrefix.ReceivableResponseTapes) ||
        tableName.startsWith(finley_types_1.DataLake.TablePrefix.ReceivableResponseTapesLatest)) {
        const lowerCaseCfSlug = splitTable.pop();
        (0, common_1.finleyAssert)(lowerCaseCfSlug, `Expected valid CF slug when extracting from Datalake [tableName:${tableName}]`);
        return { creditFacilitySlugLowerCase: lowerCaseCfSlug };
    }
    // *** Loan Product ***
    if (tableName.startsWith(finley_types_1.DataLake.TablePrefix.MasterLoanTapes) ||
        tableName.startsWith(finley_types_1.DataLake.TablePrefix.MasterLoanTapesLatest) ||
        tableName.startsWith(finley_types_1.DataLake.TablePrefix.InternalRepaymentTapes) ||
        tableName.startsWith(finley_types_1.DataLake.TablePrefix.InternalRepaymentTapesLatest)) {
        const lowerCaseLpSlug = splitTable.pop();
        (0, common_1.finleyAssert)(lowerCaseLpSlug, `Expected valid LP slug when extracting from Datalake [tableName:${tableName}]`);
        return { loanProductSlugLowerCase: lowerCaseLpSlug };
    }
    // *** Loan Product & Credit Facility ***
    if (tableName.startsWith(finley_types_1.DataLake.TablePrefix.AssignedLoanTapes) ||
        tableName.startsWith(finley_types_1.DataLake.TablePrefix.AssignedLoanTapesLatest) ||
        tableName.startsWith(finley_types_1.DataLake.TablePrefix.CovenantLoanTapes) ||
        tableName.startsWith(finley_types_1.DataLake.TablePrefix.CovenantLoanTapesLatest)) {
        const lowerCaseCfSlug = splitTable.pop();
        (0, common_1.finleyAssert)(lowerCaseCfSlug, `Expected valid CF slug when extracting from Datalake [tableName:${tableName}]`);
        const lowerCaseLpSlug = splitTable.pop();
        (0, common_1.finleyAssert)(lowerCaseLpSlug, `Expected valid LP slug when extracting from Datalake [tableName:${tableName}]`);
        return {
            loanProductSlugLowerCase: lowerCaseLpSlug,
            creditFacilitySlugLowerCase: lowerCaseCfSlug,
        };
    }
    throw new common_1.error.FinleyError(`Received unsupported Datalake [tableName:${tableName}] when trying to extract LP and CF`);
};
exports.extractLpAndCfFromDatalakeTable = extractLpAndCfFromDatalakeTable;
//# sourceMappingURL=index.js.map